"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callExpression = exports.primitive = exports.literal = exports.identifier = exports.locationDummyNode = void 0;
const lodash_1 = require("lodash");
const locationDummyNode = (line, column) => (0, exports.literal)('Dummy', { start: { line, column }, end: { line, column } });
exports.locationDummyNode = locationDummyNode;
const identifier = (name, loc) => ({
    type: 'Identifier',
    name,
    loc,
    isPointer: false
});
exports.identifier = identifier;
const literal = (value, loc) => {
    if (typeof value == 'string') {
        return { type: 'Literal', value, valueType: 'char', loc };
    }
    else if (value == null) {
        return { type: 'Literal', value, valueType: 'void', loc };
    }
    else if (typeof value === 'number' && (0, lodash_1.isInteger)(value)) {
        return { type: 'Literal', value, valueType: 'int', loc };
    }
    else {
        return { type: 'Literal', value, valueType: 'float', loc };
    }
};
exports.literal = literal;
// primitive: undefined is a possible value
const primitive = (value) => {
    return value === undefined ? (0, exports.identifier)('undefined') : (0, exports.literal)(value);
};
exports.primitive = primitive;
const callExpression = (callee, args, loc) => ({
    type: 'CallExpression',
    callee,
    arguments: args,
    loc
});
exports.callExpression = callExpression;
//# sourceMappingURL=astCreator.js.map